var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4286 3.17699C18.1903 2.45021 18.1903 1.27187 17.4286 0.545086C16.6669 -0.181695 15.4319 -0.181695 14.6702 0.545085L6.31806 8.51401L3.31791 5.65149C2.55889 4.9273 1.32828 4.9273 0.569263 5.65149C-0.189754 6.37569 -0.189755 7.54984 0.569262 8.27404L4.86455 12.3723C4.89069 12.4004 4.91789 12.428 4.94613 12.4549C5.27955 12.773 5.70365 12.9519 6.13905 12.9915C6.67505 13.0411 7.22853 12.8789 7.65025 12.5048C7.66861 12.4886 7.68673 12.472 7.70458 12.4549L17.4286 3.17699Z",
    fill: "#f75c03"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOrange);
export default __webpack_public_path__ + "static/media/check-orange.f4528ce3998e573bdb5c4e9194a741be.svg";
export { ForwardRef as ReactComponent };